import * as React from 'react';

import { Button } from '@rematter/ui-web';
import Lottie from 'react-lottie-player';

import { useTranslations } from '~/app/i18n/useTranslations';

interface RefreshOverlayProps {
  isVisible: boolean;
  onLogout: () => void;
}

export const RefreshOverlay: React.FC<RefreshOverlayProps> = ({
  isVisible,
  onLogout,
}) => {
  const [animationData, setAnimationData] = React.useState<object>();

  React.useEffect(() => {
    import('~/shared/animations/no-connection.json').then(setAnimationData);
  }, []);

  const t = useTranslations();

  if (!isVisible) return null;

  return (
    <div className="@RefreshOverlay fixed inset-0 z-[9999] flex items-center justify-center bg-neutral/50 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-6 rounded-xl border border-white/20 bg-white p-10 shadow-lg">
        <div>
          <Lottie
            play
            className="size-32"
            loop={true}
            animationData={animationData}
          />
        </div>
        <p className="w-80 text-center text-lg font-medium text-neutral/80">
          {t.sessionRefresh.reconnecting}
        </p>
        <Button
          variant="outline"
          color="failure"
          onPress={onLogout}
          className="mt-2"
        >
          {t.sessionRefresh.cancel}
        </Button>
      </div>
    </div>
  );
};
